export default "__VITE_ASSET__bcd1109f__"